module.exports = __webpack_public_path__ + "static/media/heroimage_igib-026.18f348e3.jpg";